// CO - Kit montado: gaveta de medidas (tabela + provador virtual).
//
// POR QUE SOB DEMANDA
// O plugin da Kiwi (SizingPlugin.prod.js, ~538 KB) já carrega em toda página por
// ScriptTag, então o botão não traz JS novo. O que custa é cada chart: o plugin
// varre `querySelectorAll('#KiwiSizingChart')` e dispara um
// GET /api/getSizingChart (~12 KB) POR ELEMENTO, sem deduplicar por sizingID.
// A LP dos kits tem 18 slots de roupa; renderizar as duas abas de cada um no load
// seriam 36 requisições concorrendo com o LCP. Aqui o painel de uma peça só é
// criado no primeiro clique e fica em cache na gaveta.
//
// COMO A KIWI DEIXA RENDERIZAR DEPOIS
// Elemento já processado ganha a classe `kiwiSizingLoaded` e é filtrado nas
// passadas seguintes, então `window.loadKiwiSizingChart({})` só renderiza o que
// acabou de entrar no DOM — inclusive o de outra gaveta que ainda não abriu.

(() => {
  if (window.__consoKitMedidas) return;
  window.__consoKitMedidas = true;

  // O plugin busca por id, não por classe — é por isso que a PDP consegue ter
  // três charts na mesma página com o mesmo id.
  const CHART_ID = 'KiwiSizingChart';

  // SizingChartLayoutType: 1 = RECOMMENDER_ONLY, 2 = LAYOUT_ONLY.
  // Mesmos valores dos custom-liquid das gavetas da PDP.
  const LAYOUT = { medidas: 2, provador: 1 };

  const ESPERA_MAX = 10000;
  const ESPERA_PASSO = 100;
  const CARREGANDO = 'Carregando as medidas…';

  // O ScriptTag é async: em conexão ruim o clique pode chegar antes do plugin.
  const esperarKiwi = () =>
    new Promise((resolve) => {
      if (typeof window.loadKiwiSizingChart === 'function') return resolve(true);

      let esperado = 0;
      const timer = setInterval(() => {
        if (typeof window.loadKiwiSizingChart === 'function') {
          clearInterval(timer);
          resolve(true);
        } else if ((esperado += ESPERA_PASSO) >= ESPERA_MAX) {
          clearInterval(timer);
          resolve(false);
        }
      }, ESPERA_PASSO);
    });

  const proximoQuadro = () => new Promise((resolve) => requestAnimationFrame(() => resolve()));

  // A Kiwi injeta o próprio container quando a resposta chega (~250-800 ms
  // medidos). Em vez de adivinhar onde — dentro do <div id="KiwiSizingChart"> ou
  // ao lado dele —, o critério é o painel ter ganhado QUALQUER elemento além dos
  // que montamos. Assim uma mudança de injeção do app não quebra o aviso.
  const esperarPintar = (painel, base) =>
    new Promise((resolve) => {
      const pronto = () => painel.querySelectorAll('*').length > base;
      if (pronto()) return resolve(true);

      const encerrar = (ok) => {
        clearTimeout(prazo);
        observador.disconnect();
        resolve(ok);
      };

      const observador = new MutationObserver(() => {
        if (pronto()) encerrar(true);
      });
      observador.observe(painel, { childList: true, subtree: true });

      const prazo = setTimeout(() => encerrar(pronto()), ESPERA_MAX);
    });

  const criarPainel = (corpo, sizing, comProvador) => {
    const painel = document.createElement('div');
    painel.className = 'kmm__painel';
    painel.dataset.kmmPainel = sizing;

    for (const nome of comProvador ? ['medidas', 'provador'] : ['medidas']) {
      const pane = document.createElement('div');
      pane.className = 'kmm__pane';
      pane.dataset.kmmPane = nome;

      const chart = document.createElement('div');
      chart.id = CHART_ID;
      chart.setAttribute('data-sizing-id', sizing);
      chart.setAttribute('data-display-mode', '0'); // SizingDisplayMode.INLINE
      chart.setAttribute('data-recommender-display-mode', '0');
      chart.setAttribute('data-layout-type', String(LAYOUT[nome]));

      pane.append(chart);
      painel.append(pane);
    }

    corpo.append(painel);
    return painel;
  };

  const selecionarAba = (gaveta, nome) => {
    for (const botao of gaveta.querySelectorAll('[data-kmm-aba]')) {
      const ativa = botao.dataset.kmmAba === nome;
      botao.setAttribute('aria-selected', ativa ? 'true' : 'false');
      botao.tabIndex = ativa ? 0 : -1;
    }

    const painel = gaveta.querySelector('.kmm__painel:not([hidden])');
    if (!painel) return;

    for (const pane of painel.querySelectorAll('[data-kmm-pane]')) {
      pane.hidden = pane.dataset.kmmPane !== nome;
    }
  };

  const abrir = async (botao) => {
    const gaveta = botao.closest('conso-kit-montado')?.querySelector('dialog.kmm');
    if (!gaveta) return;

    const sizing = botao.dataset.kmMedidas;
    if (!sizing) return;

    // Tênis tem tabela própria e não tem provador — mesma regra dos blocks da
    // PDP (`conso-botao-tenis-popup` × `conso-botao-popup`).
    const comProvador = botao.hasAttribute('data-km-medidas-provador');

    const titulo = gaveta.querySelector('[data-kmm-titulo]');
    if (titulo) titulo.textContent = botao.dataset.kmMedidasTitulo || 'Tabela de medidas';

    const abas = gaveta.querySelector('[data-kmm-abas]');
    if (abas) abas.hidden = !comProvador;

    const aviso = gaveta.querySelector('[data-kmm-aviso]');
    const corpo = gaveta.querySelector('[data-kmm-corpo]');
    if (!corpo) return;

    for (const outro of corpo.querySelectorAll('.kmm__painel')) outro.hidden = true;

    let painel = corpo.querySelector(`.kmm__painel[data-kmm-painel="${CSS.escape(sizing)}"]`);
    const estreando = !painel;
    if (estreando) painel = criarPainel(corpo, sizing, comProvador);
    painel.hidden = false;

    selecionarAba(gaveta, 'medidas');
    corpo.scrollTop = 0;

    if (aviso) {
      aviso.textContent = CARREGANDO;
      aviso.hidden = !estreando;
    }
    if (!gaveta.open) gaveta.showModal();

    if (!estreando) return;

    // O aviso é um só pra gaveta inteira: se o cliente pular pra outra peça no
    // meio do carregamento, quem terminar depois não pode mexer nele.
    const falhou = () => {
      if (aviso && !painel.hidden) aviso.textContent = 'Não foi possível carregar a tabela de medidas.';
    };

    // Só depois do showModal: a Kiwi mede a largura do container ao montar a
    // tabela, e dentro de um <dialog> fechado o painel está em display:none e
    // sairia zerado.
    await proximoQuadro();

    if (!(await esperarKiwi())) return falhou();

    const base = painel.querySelectorAll('*').length;
    window.loadKiwiSizingChart({});

    if (!(await esperarPintar(painel, base))) return falhou();
    if (aviso && !painel.hidden) aviso.hidden = true;
  };

  document.addEventListener('click', (evento) => {
    const alvo = evento.target instanceof Element ? evento.target : null;
    if (!alvo) return;

    const fechar = alvo.closest('[data-kmm-fechar]');
    if (fechar) {
      fechar.closest('dialog')?.close();
      return;
    }

    const aba = alvo.closest('[data-kmm-aba]');
    if (aba) {
      const gaveta = aba.closest('dialog.kmm');
      if (gaveta) selecionarAba(gaveta, aba.dataset.kmmAba);
      return;
    }

    // Clique no backdrop. A gaveta mora dentro da modal do kit, mas o alvo aqui
    // é a própria <dialog class="kmm">, que não casa com o seletor do
    // conso-kits-carrossel — os dois handlers convivem sem fechar um ao outro.
    if (alvo.matches('dialog.kmm')) {
      alvo.close();
      return;
    }

    const botao = alvo.closest('[data-km-medidas]');
    if (!botao) return;

    evento.preventDefault();
    abrir(botao);
  });

  // Kit adicionado: a sacola abre por cima e a gaveta ficaria presa no top layer,
  // mesmo motivo pelo qual o carrossel fecha a modal do kit.
  document.addEventListener('cart:update', (evento) => {
    if (evento.detail?.data?.source !== 'conso-kit-montado') return;

    for (const gaveta of document.querySelectorAll('dialog.kmm[open]')) gaveta.close();
  });
})();
